import React, { useState } from 'react'

import { useSelector } from 'react-redux'

import { P } from '../../../../style/Typography.style'

import Flex from '../../../layouts/Flex'

import { SingleDropdownSelect } from '../DropdownSelect'
import Assessments from '../Assessments'

import useFetch from '../../../../hooks/useFetch'

const ApplicantScorecard = () => {
  const { selectedInterview } = useSelector((state) => state.requisitions)

  const [stage, setStage] = useState({ name: '1st Interview', id: 1 })

  const { data: stagesData } = useFetch('/stages')

  const handleSelectStage = (e) => {
    const selectedId = e.target.value
    setStage(selectedId)

    const selectedStage = stagesData?.result.find(
      (stage) => String(stage?.id) === String(selectedId)
    )

    if (selectedStage) setStage(selectedStage)
  }

  return (
    <>
      <Flex direction="column" gap="1rem" margin="0 0 1rem 0">
        <Flex items="center" gap="1rem" width="100%">
          <P width="50%">Stage</P>
          <SingleDropdownSelect
            maxw="50%"
            mb="0"
            onChange={handleSelectStage}
            value={stage?.id}
          >
            {stagesData?.result
              ?.filter((stage) => {
                if (selectedInterview?.stageName === '1st Interview')
                  return stage?.name === '1st Interview'

                return (
                  stage?.name === '1st Interview' ||
                  stage?.name === '2nd Interview'
                )
              })
              .map((stage) => {
                return (
                  <option key={stage?.id} value={stage?.id}>
                    {stage?.name}
                  </option>
                )
              })}
          </SingleDropdownSelect>
        </Flex>
      </Flex>

      <hr />

      <Flex direction="column">
        <Assessments stage={stage} interviewId={selectedInterview.id} />
      </Flex>
    </>
  )
}

export default ApplicantScorecard
